import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Make sure this path is correct. 
// If your folder is src/styles/tailwind.css, this is perfect.
import "./styles/tailwind.css"; 

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);